import { useSetDialogState, type SetDialogStateHookReturn } from '../useSetDialogState/useSetDialogState'
import { useDialogState, type DialogStateHookReturn } from '../useDialogState/useDialogState'

type DialogHookReturn<T> = [DialogStateHookReturn<T>[0], SetDialogStateHookReturn<T>, DialogStateHookReturn<T>[1]]
type DialogStateData<T = any> = Record<string, T>

/**
 * Use this hook for dialog state management.
 * The dialog state is stored in the global Zustand state.
 * @name useDialog
 * @param {string} id - Dialog id
 */
export const useDialog = <T = DialogStateData>(id: string): DialogHookReturn<T> => {
  const [open, data] = useDialogState<T>(id)
  const setDialogState = useSetDialogState<T>(id)

  return [open, setDialogState, data]
}
